import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import axios, { AxiosError, AxiosRequestConfig, Method } from 'axios';

const axiosBaseQuery =
    (
        { baseUrl }: { baseUrl: string } = { baseUrl: '' }
    ): BaseQueryFn<
        | string
        | {
              url: string;
              method: AxiosRequestConfig['method'];
              body?: AxiosRequestConfig['data'];
              params?: AxiosRequestConfig['params'];
          },
        unknown,
        unknown
    > =>
    async (input: string | { url: string; method: Method; body: any; params: any }) => {
        try {
            let requestConfig: any = {};
            if (typeof input === 'string') {
                requestConfig = {
                    url: baseUrl + input,
                    method: 'GET',
                };
            } else {
                requestConfig = {
                    ...input,
                    data: input.body,
                };
            }
            const result = await axios(requestConfig);
            return { data: result.data };
        } catch (axiosError) {
            let err = axiosError as AxiosError;
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            };
        }
    };

export const sojusApi = createApi({
    reducerPath: 'sojusApi',
    baseQuery: axiosBaseQuery(),
    tagTypes: [
        'Accounting',
        'AccountingList',
        'AccountingOption',
        'AccountingOptionsForUser',
        'ApiKeyList',
        'ArrangementType',
        'ArrangementTypeList',
        'ArtistApplication',
        'ArtistApplicationCategory',
        'ArtistApplicationDetail',
        'ArtistApplicationEmailTemplate',
        'Attendance',
        'BackstageList',
        'Car',
        'CarRentalCrew',
        'CarRentalOrder',
        'CarType',
        'CashTemplateList',
        'CheckIn',
        'CheckInList',
        'Crew',
        'CrewList',
        'CrewAdminList',
        'CrewType',
        'DashboardData',
        'DashboardDataAttendances',
        'DashboardDataTicketing',
        'InstanceToolbarBookings',
        'KitchenList',
        'Location',
        'Person',
        'PersonAccountingComments',
        'PersonAttendance',
        'PersonList',
        'PersonData',
        'PersonDiscourse',
        'PersonLog',
        'PersonalData',
        'PersonRoleList',
        'Plugin',
        'Project',
        'ProjectBackstage',
        'ProjectBackstageList',
        'ProjectCash',
        'ProjectCashAmount',
        'ProjectCashDealType',
        'ProjectCashPeriodGroup',
        'ProjectCashTemplate',
        'ProjectCrew',
        'ProjectCrewAdmin',
        'ProjectCrewArrangement',
        'ProjectCrewDealCalculation',
        'ProjectCrewHistoryEvent',
        'ProjectCrewLogbook',
        'ProjectCrewLogbookList',
        'ProjectCrewManager',
        'ProjectCrewMappedArrangement',
        'ProjectCrewNews',
        'ProjectCrewPersonConfirmedWorkingDay',
        'ProjectCrewPersonProjectCrewProjectKitchenPeriod',
        'ProjectCrewPersonWorkingPeriod',
        'ProjectCrewProjectCashDealType',
        'ProjectCrewStewardList',
        'ProjectCrewSupporterDemand',
        'ProjectCrewTicketing',
        'ProjectCrewBackstages',
        'ProjectKitchen',
        'ProjectKitchenList',
        'ProjectList',
        'ProjectNews',
        'ProjectPretixConfig',
        'ProjectToolFlatRate',
        'RadioRentalCategory',
        'RadioRentalOrder',
        'RadioRentalOrderNote',
        'RadioRentalRentalPeriod',
        'RadioRentalProduct',
        'RadioRentalProjectCrew',
        'RentableTool',
        'RentableToolUser',
        'RoleList',
        'Shift',
        'ShiftTag',
        'SupporterScheduleLocation',
        'SupporterScheduleShift',
        'SupporterScheduleShiftTag',
        'StewardInstruction',
        'StewardList',
        'SupporterDemand',
        'SupporterDemandList',
        'SupporterList',
        'TicketOptionType',
        'TicketOptionTypeList',
        'TicketToasterCurrency',
        'TicketType',
        'TicketTypeList',
        'ToolbarBookings',
        'ToolToolbarBookings',
        'UserToolbarBookings',
        'UserType',
        'WorkingStatus',
        'Wristband',
        'WristbandList',
    ],
    endpoints: () => ({}),
});
